import { getState } from "../../store/state.js";
import DocumentTable, { chunkCount } from "./DocumentTable";
import DocumentUpload from "./DocumentUpload";
import { t } from "../../i18n/index.js";
import type { KbDocument } from "../../types/index.js";

export default function KnowledgeBase({ onOpen, onChanged }: {
  onOpen: (id: string) => void; onChanged: () => void;
}) {
  const documents: KbDocument[] = getState().kbDocuments;
  const stats = [
    { key: "indexedDocs", value: documents.length },
    { key: "chunks", value: documents.reduce((sum, document) => sum + chunkCount(document), 0) },
    { key: "categories", value: new Set(documents.map(document => document.category)).size },
  ];

  return <>
    <header className="admin-head">
      <div>
        <div className="crumb">{t("admin.kb.crumb")}</div>
        <h1>{t("admin.kb.title")}</h1>
        <p>{t("admin.kb.subtitle")}</p>
      </div>
    </header>

    <section className="admin-stats">
      {stats.map(stat => <article key={stat.key}>
        <strong>{stat.value}</strong><span>{t(`admin.kb.${stat.key}`)}</span>
      </article>)}
    </section>

    <DocumentUpload onIngested={onChanged} />
    <DocumentTable documents={documents} onOpen={onOpen} />
  </>;
}
